import { useAtom } from 'jotai'
import { createAtom } from './atomFactory'
import { MMKVKey } from '../mmkv'
import { BiometryInfo } from '../types'

const { atom, resetAtom } = createAtom<BiometryInfo>({} as BiometryInfo, MMKVKey.HasSavedBiometry)

export const useHasSavedBiometry = () => useAtom(atom)
export const useResetHasSavedBiometry = () => useAtom(resetAtom)
